<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4"><T t="public_information.title" /></h1>
            </div>

            <div class="col-span-12 lg:col-span-8 lg:col-start-2 sm:mt-4">
                <div v-if="informations.length">
                    <div
                        v-for="(item, i) in informations"
                        :key="item.id"
                        class="flex flex-col sm:flex-row justify-between items-start sm:items-center"
                        :class="{ 'border-t border-black pt-8 mt-8': i > 0 }"
                    >
                        <div class="mb-4 sm:mb-0">
                            <NuxtLink
                                :to="localePath({ name: 'public-information-data', params: { data: item.slug } })"
                                class="lg-lead sm:mr-4"
                            >
                                {{ item.name }}
                            </NuxtLink>
                        </div>
                        <Button
                            :to="localePath({ name: 'public-information-data', params: { data: item.slug } })"
                            :label="$t('public_information.result_card_button_label')"
                        />
                    </div>
                </div>

                <div v-else class="md-lead"><T t="public_information.no_results_text" /></div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
export default {
    name: 'PublicInformationIndex',
    components: {
        Wrapper,
    },
    async asyncData({ $axios, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('/'));
        }

        let informations = [];

        await $axios
            .$get('/public-information')
            .then((res) => {
                informations = res.data;
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('public_information.title'), 'public-information']);

        return {
            breadcrumbItems,
            informations,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('public-information.index'),
            meta: this.$getPageMetaData('public-information.index'),
        };
    },
};
</script>

<style scoped></style>
